const state = {
    cpm: [],
    companies: [],
    successFactors: [],
};

const mutations = {
    setCpm(state, value) {
        state.cpm = value;
    },
    setCompanies(state, value) {
        state.companies = value;
    },
    setSuccessFactors(state, value) {
        state.successFactors = value;
    },
    mergeMyCompanyName(state, value) {
        state.companies.unshift(value)
    },
};

const actions = {};

const getters = {
    cpm: (state) => state.cpm,
    companies: (state) => state.companies,
    successFactors: (state) => state.successFactors,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
